var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "px-5 pt-16 status-page", attrs: { justify: "center" } },
    [
      _c(
        "v-col",
        { attrs: { xl: "8", lg: "8", md: "10", sm: "12", cols: "12" } },
        [
          _c("a", { staticClass: "no-decor", attrs: { href: "/" } }, [
            _vm._v("Back to SmartTMS"),
          ]),
          _c(
            "v-card",
            { staticClass: "pa-6 mt-4 elevation-2" },
            [
              _c("label", { staticClass: "api-name" }, [
                _vm._v("Suggest Freight Class"),
              ]),
              _c(
                "v-alert",
                {
                  staticClass: "mt-4 custom-alert",
                  attrs: { type: "warning", prominent: "" },
                },
                [
                  _c("strong", [_vm._v("Important:")]),
                  _vm._v(
                    " The NMFC calculation logic for determining freight classes will be updated on July 19th 2025. This update will affect how freight classes are determined based on new rules. This API will automatically apply new rules starting July 19th 2025, so if you call it before rating, booking, or add pending order APIs you don't have to worry about manual calculation of freight class. "
                  ),
                ]
              ),
              _c("p", { staticClass: "mt-4" }, [
                _vm._v(
                  " This API endpoint allows you to get a suggested freight class based on the dimensions and weight of your shipment. The freight class is determined using NMFC calculation logic, which considers the density of the shipment. "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  " This endpoint is particularly useful when you need to determine the appropriate freight class for your shipment before booking it with a carrier. "
                ),
              ]),
              _c(
                "v-row",
                { staticClass: "endpoint-row" },
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("API endpoint: "),
                      _c("code", [
                        _vm._v(
                          "[POST] " +
                            _vm._s(_vm.baseUrl) +
                            "/freight-classes/suggest"
                        ),
                      ]),
                    ]),
                    _c("span", { staticClass: "value" }),
                  ]),
                ],
                1
              ),
              _c("label", { staticClass: "mt-8 sub-section" }, [
                _vm._v("HTTP Headers"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("span", { staticClass: "label" }, [
                      _c("code", [
                        _vm._v("Authorization: Bearer <access token>"),
                      ]),
                    ]),
                  ]),
                  _c("v-col", { staticClass: "mt-n2", attrs: { cols: "12" } }, [
                    _c("span", { staticClass: "label" }, [
                      _c("code", [_vm._v("Content-Type: application/json")]),
                    ]),
                  ]),
                ],
                1
              ),
              _c("br"),
              _c("label", { staticClass: "mt-8 sub-section" }, [
                _vm._v("Request Fields"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                { staticClass: "table-header mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("Field")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("Type")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "require-col", attrs: { cols: "2" } },
                    [_vm._v("Required")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "6" } },
                    [_vm._v("Description")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "table-row mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("height")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("integer")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "require-col", attrs: { cols: "2" } },
                    [_vm._v("yes")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "6" } },
                    [
                      _vm._v(
                        " The height of the shipment item in the specified units. "
                      ),
                      _c("br"),
                      _vm._v(" Example: "),
                      _c("pre", [_c("code", [_vm._v("11")])]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "table-row mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("width")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("integer")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "require-col", attrs: { cols: "2" } },
                    [_vm._v("yes")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "6" } },
                    [
                      _vm._v(
                        " The width of the shipment item in the specified units. "
                      ),
                      _c("br"),
                      _vm._v(" Example: "),
                      _c("pre", [_c("code", [_vm._v("14")])]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "table-row mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("length")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("integer")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "require-col", attrs: { cols: "2" } },
                    [_vm._v("yes")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "6" } },
                    [
                      _vm._v(
                        " The length of the shipment item in the specified units. "
                      ),
                      _c("br"),
                      _vm._v(" Example: "),
                      _c("pre", [_c("code", [_vm._v("13")])]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "table-row mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("units")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("integer")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "require-col", attrs: { cols: "2" } },
                    [_vm._v("yes")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "6" } },
                    [
                      _vm._v(" The unit of measurement for the dimensions. "),
                      _c("br"),
                      _vm._v(" Example: "),
                      _c("pre", [_c("code", [_vm._v("1")])]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "table-row mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("weight")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("integer")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "require-col", attrs: { cols: "2" } },
                    [_vm._v("yes")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "6" } },
                    [
                      _vm._v(" The total weight of the shipment item. "),
                      _c("br"),
                      _vm._v(" Example: "),
                      _c("pre", [_c("code", [_vm._v("200")])]),
                    ]
                  ),
                ],
                1
              ),
              _c("br"),
              _c("label", { staticClass: "mt-8 sub-section" }, [
                _vm._v("Example Request"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("pre", [
                      _c("code", [
                        _vm._v(
                          '{\n  "height": 11,\n  "width": 14,\n  "length": 13,\n  "units": 1,\n  "weight": 200\n}'
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
              _c("br"),
              _c("label", { staticClass: "mt-8 sub-section" }, [
                _vm._v("Response Fields"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                { staticClass: "table-header mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("Field")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("Type")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "8" } },
                    [_vm._v("Description")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "table-row mx-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "field-col", attrs: { cols: "2" } },
                    [_vm._v("data.suggestedClass")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "type-col", attrs: { cols: "2" } },
                    [_vm._v("decimal")]
                  ),
                  _c(
                    "v-col",
                    { staticClass: "description-col", attrs: { cols: "8" } },
                    [
                      _vm._v(
                        " The suggested freight class for the shipment based on the provided dimensions and weight. "
                      ),
                      _c("br"),
                      _vm._v(" Example: "),
                      _c("pre", [_c("code", [_vm._v("77.5")])]),
                    ]
                  ),
                ],
                1
              ),
              _c("br"),
              _c("label", { staticClass: "mt-8 sub-section" }, [
                _vm._v("Example Response"),
              ]),
              _c("v-divider", { staticClass: "mt-2 mb-6" }),
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("pre", [
                      _c("code", [
                        _vm._v(
                          '{\n  "data": {\n    "suggestedClass": 77.5\n  }\n}'
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }